import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'context/auth/authcontext';

interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { jwt } = useAuth();

  if (!jwt) {
    // Redirect to login if not authenticated
    return <Navigate to='/' replace />;
  }

  return children;
};

export default ProtectedRoute;
